import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import LocationLockingLineDto from '../entities/location-locking/locationlockingline';

interface LocationLockingLineState extends ListState<LocationLockingLineDto>{

}
class LocationLockingLineMutations extends ListMutations<LocationLockingLineDto>{

}
class LocationLockingLineModule extends ListModule<LocationLockingLineState,any,LocationLockingLineDto>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<LocationLockingLineDto>(),
        loading:false,
    }
    actions={
        async getAll(context:ActionContext<LocationLockingLineState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/LocationLockingLine/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<LocationLockingLineDto>;
            context.state.totalCount=page.totalCount;
            context.state.list= page.items;
        },
        
    };
    mutations={
        setCurrentPage(state:LocationLockingLineState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:LocationLockingLineState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const locationLockingLineModule=new LocationLockingLineModule();
export default locationLockingLineModule;